/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-use-before-define */
/* eslint-disable import/no-cycle */
/* eslint-disable no-param-reassign */
import { AxiosResponse } from 'axios';
import { path } from 'rambda';
import { defineModule } from 'direct-vuex';
import { modActionCtx, modGetterCtx } from '@/store/index';
import { api } from '@/utils/apiInstance';
import {
  basicOfficeFetch, getFetchState, FetchStateInterface, getFetchMutations,
} from '@/store/storeUtils';
import {
  PENDING, REJECTED,
} from '@/utils/statuses';

export interface UserDashboard {
  activePartners: {
    countAll: number | string,
    countInFirstLine: number | string,
    plusFromLastWeek: number | string,
  },
}

export type DashboardResponse = AxiosResponse<{ data: UserDashboard }>;

const userDashboardStore = defineModule({
  namespaced: true,
  state: {
    ...getFetchState<DashboardResponse>(),
  } as FetchStateInterface<DashboardResponse>,

  getters: {
    data(...args): UserDashboard | undefined {
      const { state } = getterCtx(args);

      const result = path('data.data', state.response) as UserDashboard;

      return result;
    },
  },
  mutations: {
    ...getFetchMutations(),
  },
  actions: {

    async fetch(ctx) {
      const { commit, state } = actionCtx(ctx);

      if (state.fetchState === PENDING) {
        return;
      }

      await basicOfficeFetch({
        method: api.office.sendPost,
        props: {
          url: '/user/dashboard',
          data: {},
        },
        setState: commit.SET_STATE,
        // update state
        callback: (fetchState) => {
          if (fetchState === REJECTED) {
            console.error('Fetch error in userDashboardStore.fetch, status: ', REJECTED);
          }
        },
      });
    },
  },
});

export default userDashboardStore;
const getterCtx = (args: [any, any, any, any]) => modGetterCtx(args, userDashboardStore);
const actionCtx = (ctx: any) => modActionCtx(ctx, userDashboardStore);
